import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import {
    GenericCameraSettings,
    GenericCameraSettingsChild,
    InputType,
    CameraSettingsErrorStateMatcher,
    RenderType
} from '@pages/camera-settings/models';

@Component({
    selector: 'mat-generic-form-field-disabled',
    templateUrl: './mat-generic-form-field-disabled.component.html',
    styleUrls: ['./mat-generic-form-field-disabled.component.scss']
})
export class MatGenericFormFieldDisabledComponent implements OnInit {
    @Input() property: GenericCameraSettings;
    @Input() disabled: boolean = false;
    @Input() manualRefresh : EventEmitter<void> = new EventEmitter<void>();
    @Output() onChange = new EventEmitter<any>();
    
    @Input() form!: FormGroup;
    options: any;
    get isValid() {
        if (this.form) {
            return this.form.controls[this.property.propertyName].valid;
        } else {
            return false;
        }
    }

    childProperties: GenericCameraSettingsChild[] = [];
    public get RenderType(): typeof RenderType {
        return RenderType;
    }
    public get InputType(): typeof InputType {
        return InputType;
    }
    constructor() { }

    matcher = new CameraSettingsErrorStateMatcher();

    ngOnInit(): void {
        if (this.property.renderType == RenderType.Slider) {
            this.options = {
                floor: this.property.min,
                ceil: this.property.max,
                step: 1,
                showTicks: true,
                disabled : true
            }
        }
    }

    textBoxUpdate($event: any) {
        this.property.value = $event.target.value;
    }
    dropdownUpdate($event: MatSelectChange) {
        this.property.value = $event.value;
    }
    toggleUpdate($event: MatSlideToggleChange) {
        this.property.value = $event.checked;
        this.onChange.next($event.checked);
    }
    checkBoxUpdate($event: any) {
        this.property.value = $event.checked;
    }
}
